<template>
 <b-form-group v-if="response.additional_costs.length">
  <b-card>
    <b-container fluid>
      <b-form-row v-for="(additional_cost, additional_cost_index) in response.additional_costs" :key="additional_cost_index">
        <b-col lg="4" md="4" sm="12">
          <b-form-group v-bind:id="'amount-' + additional_cost_index" 
          :label="additional_cost_index == 0 ? 'Additional Costs:' : ''" 
          v-bind:label-for="'input-amount-' + additional_cost_index + id" label-class="quote-summary-label">
            <b-input-group>
              <b-form-input
             class="quote-summary-value"
                v-bind:id="'input-amount-' + additional_cost_index + id"
                v-bind:value="costLabel(additional_cost.amount)"
                :number="true"
                v-bind:plaintext="true"
                disabled
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="4" md="4" sm="12">
          <b-form-group v-bind:id="'additional_cost_label-' + additional_cost_index" 
          :label="additional_cost_index == 0 ? 'Type:' : ''" 
          v-bind:label-for="'input-additional_cost_label-' + additional_cost_index + id" label-class="quote-summary-label">
            <b-form-input
             class="quote-summary-value"
              v-bind:id="'input-additional_cost_label-' + additional_cost_index + id"
              v-model="additional_cost.label"
              v-bind:plaintext="true"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>  

        <b-col lg="4" md="4" sm="12">
          <b-form-group v-bind:id="'additional_cost_per_unit-' + additional_cost_index" 
          :label="additional_cost_index == 0 ? 'Per:' : ''" 
          v-bind:label-for="'input-additional_cost_per_unit-' + additional_cost_index + id" label-class="quote-summary-label">
            <b-form-input
             class="quote-summary-value"
              v-bind:id="'input-additional_cost_per_unit-' + additional_cost_index + id"
              v-bind:value="perLabel(additional_cost.per_unit)"
              v-bind:plaintext="true"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-container>
  </b-card>
</b-form-group>
</template>

<script>
export default {
  name: "rfqs-additional-cost",
  props: [
    'response',
    'id'
  ],
  methods: {
    costLabel: function(value) {
      return value ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(value) : "(free)";
    },
    perLabel: function(value) {
      if (value) {
        return "Line"
      }
      return "Order"
    }
  }
};
</script>

<style scoped>
.form-group {
    margin-bottom: 0.2rem;
}
</style>